import { Grid } from '@mui/material';
import React, { useEffect } from 'react';
import Footer from '../components/resuableComponents/Footer';
import Navbar from '../components/resuableComponents/Navbar/Navbar';
import LoginFormNew from '../form/LoginFormNew';

const LoginPage = () => {
	useEffect(() => {
		window.scrollTo(0, 0);
	}, []);
	return (
		<>
			<Navbar />
			<Grid container style={{ background: '#e6e7e8' }}>
				<Grid item xs={12} lg={4}></Grid>
				<Grid item xs={12} lg={4}>
					<LoginFormNew />
				</Grid>
				<Grid item xs={12} lg={4}></Grid>
			</Grid>
			<Footer />
		</>
	);
};

export default LoginPage;
